import { render, staticRenderFns } from "./ViewDialog.vue?vue&type=template&id=24bc8de4"
import script from "./ViewDialog.vue?vue&type=script&lang=js"
export * from "./ViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports